<template>
  <GestioneDepositi />
</template>

<script>
import GestioneDepositi from '../components/fatturazione/GestioneDepositi.vue'

export default {
  pageName: 'GestioneDepositi',
  components: {
    GestioneDepositi
  },
  mounted () {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  }
}
</script>

